import { ChangeDetectionStrategy, Component, ElementRef, Injector, OnInit } from '@angular/core';
import { slideInAnimation } from './animations';
import { ActivationEnd, ChildrenOutletContexts, Router, RouterOutlet } from '@angular/router';
import { CoreService, ServiceList } from 'core';
import { AppDetailsModel } from 'core/lib/services/models/app-details.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    slideInAnimation
  ]
})
export class AppComponent implements OnInit {
  title = 'hybrid-platform';
  // links = [{
  //   icon: 'house',
  //   path: '/home',
  //   id: 'home'
  // },
  // {
  //   icon: 'magnifying-glass',
  //   path: '/search',
  //   id: 'search',
  // },
  // {
  //   icon: 'map-location-dot',
  //   path: '/map',
  //   id: "map"
  // },]
  links = [
    {
      icon: 'people-line',
      path: '/home',
      id: 'queue'
    },
    // {
    //   icon: "circle-info",
    //   path: '',
    //   link: "https://getinline.lafleetweek.org",
    //   id: "info"
    // }
  ]
  hideFooter: boolean = false;
  constructor(private contexts: ChildrenOutletContexts, private injectorObj: Injector, private elementRef: ElementRef, private router: Router) {
    // this.injectorObj.get(CoreService).boot()
    this.router.events.subscribe(data => {
      if (data instanceof ActivationEnd) {
        
        const footerData = data.snapshot.data?.['footer'];
        this.hideFooter = footerData?.show??false
      }
    });
  }
  ngOnInit(): void {
    this.injectorObj.get(CoreService).appLoadedSubject.subscribe((appData) => {
      console.log(appData)
      this.elementRef.nativeElement.style.setProperty('--accent-color', (appData as AppDetailsModel).web_app_primary_color)
      this.elementRef.nativeElement.style.setProperty('--ion-color-primary', (appData as AppDetailsModel).web_app_primary_color)
      // this.injectorObj.get(CoreService).preloadData([ServiceList.Tour, ServiceList.SiteSection, ServiceList.Exhibit])
    // this.elementRef.nativeElement.style.setProperty('--secondary-info', '#696969')
      this.injectorObj.get(CoreService).preloadData([ServiceList.DigitalQueue])

    })
    // this.injectorObj.get(CoreService).preloadData([ServiceList.Tour, ServiceList.Category, ServiceList.SiteSection])
  }
  // getState(outlet: RouterOutlet) {
  //   // console.log(outlet)
  //   // Changing the activatedRouteData.state triggers the animation
  //   return outlet.activatedRouteData['state'];
  // }
  // hideBottomBar(): boolean {
  //   const footerData  = this.contexts.getContext('primary')?.route?.snapshot?.data?.['footer']
  //   return footerData?.show??false
  //   // let hideFor = ['splash']
  //   // let hide = true
  //   // hideFor.forEach((hx) => {
  //   //   if (this.router.url == hx) {
  //   //     hide = true
  //   //   }
  //   // })
  //   // return hide
  // }
}
